import { List, Modal, Spin } from "antd";
import React, { useEffect, useState } from "react";
import FacultyCardRankCompare from "Benchmarking/Components/FacultyCardRankCompare";
import ItemCompareFaculty from "Benchmarking/Components/ItemCompareFaculty";
import MultiLineChart from "Benchmarking/Components/MultiLineChart";
import RadarChart from "Benchmarking/Components/RadarChart";
import SearchAdvanceFacultyModal from "Benchmarking/Components/SearchAdvanceFacultyModal";
import { findMax } from "Benchmarking/Config/UtilFunction";
import "Benchmarking/Scss/CompareFaculty.scss";
import {
  getAuthorCompare,
  getAuthorRank,
  getSearchAuthors,
} from "Benchmarking/Services/Author";

const CompareFaculty = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [openAdd, setOpenAdd] = useState(false);
  const [searchResultList, setSearchResultList] = useState([]);
  const [candidateIndex, setCandidateIndex] = useState(-1);
  const [candidateList, setCandidateList] = useState({
    0: null,
    1: null,
    2: null,
    3: null,
  });
  const [candidateIdList, setCandidateIdList] = useState([]);
  const [candidates, setCandidates] = useState([]);
  const [filters, setFilters] = useState({
    query: null,
    seniorities: null,
    positions: null,
    institutions: null,
    departments: null,
    classifications: null,
    states: null,
  });
  const [maxData, setMaxData] = useState({});
  useEffect(() => {
    if (
      filters.query !== null ||
      filters.seniorities !== null ||
      filters.positions !== null ||
      filters.institutions !== null ||
      filters.departments !== null ||
      filters.classifications !== null ||
      filters.states !== null
    ) {
      setIsLoading(true);
      getAuthorRank(filters, (res) => {
        setSearchResultList(res);
        setIsLoading(false);
      });
    }
  }, [filters]);
  useEffect(() => {
    if (candidateIdList.length > 0) {
      getAuthorCompare(candidateIdList, (res) => {
        setCandidates(res);
        setMaxData(findMax(res));
        const data_add = res.find(
          (item) => item.id === candidateIdList[candidateIdList.length - 1]
        );
        if (candidateIndex !== -1) {
          setCandidateList({
            ...candidateList,
            [candidateIndex]: {
              data: data_add,
              filters: filters,
            },
          });
        }
      });
    }
  }, [candidateIdList]);

  const handleOk = () => {
    setOpenAdd(false);
  };
  const handleCancel = () => {
    setOpenAdd(false);
  };
  return (
    <div className="compare-faculty-member">
      <Modal
        title="Search for candidate"
        open={openAdd}
        onOk={handleOk}
        onCancel={handleCancel}
        width={1000}
        style={{
          top: 20,
        }}
      >
        <SearchAdvanceFacultyModal filters={filters} setFilters={setFilters} />
        {isLoading ? (
          <div
            style={{
              width: "100%",
              height: "100%",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <Spin />
          </div>
        ) : (
          <div className={searchResultList.length > 3 ? "data-content" : ""}>
            <List
              grid={{
                gutter: 25,
                column: 4,
              }}
              dataSource={searchResultList}
              renderItem={(item, index) => {
                return (
                  <List.Item key={index}>
                    <FacultyCardRankCompare
                      data={item}
                      candidateList={candidateList}
                      setCandidateList={setCandidateList}
                      candidates={candidates}
                      setCandidates={setCandidates}
                      setOpenAdd={setOpenAdd}
                      candidateIndex={candidateIndex}
                      isCompare={true}
                      filters={filters}
                      candidateIdList={candidateIdList}
                      setCandidateIdList={setCandidateIdList}
                    />
                  </List.Item>
                );
              }}
            />
          </div>
        )}
      </Modal>
      <p className="header">Select suitable candidates</p>
      <div className="compare-list">
        <ItemCompareFaculty
          candidateList={candidateList}
          setCandidateList={setCandidateList}
          candidateIdList={candidateIdList}
          setCandidateIdList={setCandidateIdList}
          setCandidateIndex={setCandidateIndex}
          candidates={candidates}
          setCandidates={setCandidates}
          setOpenAdd={setOpenAdd}
          maxData={maxData}
        />
      </div>
      <div className="graphs">
        <div className="citation-chart">
          {candidates.length > 0 && <MultiLineChart data={candidates} />}
        </div>
        <div className="radar-chart">
          {candidates.length > 0 && <RadarChart data={candidates} />}
        </div>
      </div>
    </div>
  );
};

export default CompareFaculty;
